import { ProfileAvatarCategory } from '@intigral/domain/lib/entity/interface/iProfile';
import { isValidUrl } from '@intigral/utils';
import user from './user';

export const getSelectedProfileAvatars = (
    profile: { avatarId: string; avatar: string; kidsMode: boolean },
    profileAvatars?: ProfileAvatarCategory[]
) => {
    if (profile?.avatar && isValidUrl(profile.avatar)) {
        return profile.avatar;
    }

    const profileId = profile?.avatarId?.split('-')?.[0];

    const selectedAvatar =
        profileAvatars &&
        profileAvatars.length > 0 &&
        profileAvatars?.reduce((found, profileAvatar) => {
            if (found) return found;
            if (profileAvatar.id === profileId) {
                const matched = profileAvatar.avatarPictures?.find((picture) => picture.avatarId === profile?.avatarId);
                if (matched) return matched.imageUrl;
            }
            return null;
        }, '');

    if (selectedAvatar) {
        return selectedAvatar;
    }
    return user.getProfileAvatar(profile?.kidsMode ? 'kid' : 'profile') || '';
};
